// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Уряд» (Government, ключ `gov`, група `relationship-management`). */
export const governmentManifest: IModuleManifest = {
  key: 'gov',
  group: 'relationship-management',
  slug: 'government',
  prefix: 'GOV',
  name: { en: 'Government', uk: 'Уряд' },
  entities: [
    { key: 'gov', slug: 'gov', name: { en: 'Interactions', uk: 'Взаємодії' }, main: true },
    { key: 'govbill', slug: 'govbill', name: { en: 'Government bills', uk: 'Урядові законопроєкти' }, main: false },
    { key: 'govprog', slug: 'govprog', name: { en: 'Action programme', uk: 'Програма дій' }, main: false },
    { key: 'govq', slug: 'govq', name: { en: 'Questions to the Government', uk: 'Питання до Уряду' }, main: false },
  ],
  loadState: () => import('./state/governmentSlice').then((m) => m.governmentSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
